import { Box, useTheme } from "@mui/material";
import { PageHeader } from "../../page-manager/PageHeader";
import { Header2 } from "../../ui-elements/typography/Header2";
import { Subtitle } from "../../ui-elements/typography/Subtitle";

export const PartnershipsContactPageHeader = () => {
  const theme = useTheme();
  return (
    <PageHeader>
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignSelf={"center"}
        paddingLeft={"24px"}
        paddingRight={"24px"}
        paddingTop={{ xs: "24px", sm: "0px" }}
        paddingBottom={{ xs: "24px", sm: "0px" }}
        width={"100%"}
        height={"100%"}
        maxWidth={"948px"}
      >
        <Header2
          text={`We're excited to partner with you!`}
          textAlign="left"
          color={theme.palette.colors.grayScale.white}
          sx={{ marginBottom: "16px" }}
        />

        <Subtitle
          text={`Please fill out the form below and we will get back to you as soon as possible.`}
          textAlign="left"
          color={theme.palette.colors.grayScale.white}
          sx={{
            opacity: 0.8,
          }}
        />
      </Box>
    </PageHeader>
  );
};
